"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var react_tooltip_1 = __importDefault(require("react-tooltip"));
var DELAY_HIDE_MILLISECOND = 500;
var TooltipCashbackContracts = function (props) {
    var tooltipId = "react_tooltip_cashback_contracts_" + Math.random().toString(32).substring(2);
    return (
    // CashbacContracts それぞれの data-for と ReactTooltip の id にユニークな文字列をセットする必要がある
    // セットしない場合、同ページ内に複数 ReactTooltip を設定する場合正常に表示されない
    react_1.default.createElement("span", { "data-tip": "tooltip", "data-for": tooltipId },
        props.label,
        react_1.default.createElement(react_tooltip_1.default, { border: true, clickable: true, id: tooltipId, className: "tooltipsCashBackContracts-Tooltip_Wrapper", type: "light", effect: "solid", delayHide: DELAY_HIDE_MILLISECOND },
            react_1.default.createElement("div", { className: "tooltipsCashBackContracts-Tooltip_Title" }, props.title),
            react_1.default.createElement("div", null, "\u5BFE\u8C61\u5546\u54C1"),
            react_1.default.createElement("ul", { className: "tooltipsCashBackContracts-Tooltip_ImportCategoryListWrapper" }, props.import_category_rows.map(function (row, i) {
                return (react_1.default.createElement("li", { key: i, className: "tooltipsCashBackContracts-Tooltip_ImportCategory" },
                    row.name,
                    " ",
                    row.amount));
            })),
            react_1.default.createElement("div", null,
                "\u8A73\u3057\u304F\u306F",
                react_1.default.createElement("a", { href: props.link_to }, "\u3053\u3061\u3089")))));
};
exports.default = TooltipCashbackContracts;
